import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../_components/Loading';
import { apiConstants } from '../_constants';
import { answerService } from '../_services/answer.service';
import { millisecondsToHHMMSS } from '../_services/misc.service';

export const EdraaquizLeaderBoard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [progressData, setProgressData] = useState({});
  const [scoreBoard, setScoreBoard] = useState([]);
  const [result, setResult] = useState('');
  const [resultConstant, setResultContent] = useState('');
  const { edraaquizId, currentExamTime } = location.state;
  const [query, setQuery] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 10,
    },
  });
  console.log(progressData, scoreBoard, resultConstant, result);
  useEffect(() => {
    getProgress(1);
  }, []);

  const getProgress = (pageNo) => {
    setIsLoading(true);
    let queryNew = query;
    // setting mocktest id and topic id for result
    queryNew.pageVo.pageNo = pageNo;
    queryNew.edraakquizid = edraaquizId;
    if (currentExamTime) {
      queryNew.currentExamTime = currentExamTime;
    }
    setQuery(queryNew);
    //for checking progress from result page

    answerService.getEdraaquizProgress(queryNew).then(
      (res) => {
        setIsLoading(false);
        if (res.data) {
          setProgressData(res.data.progressData[0]);
          setScoreBoard(res.data.scoreBoard.rows);
          calculatePercentage(res.data.progressData[0]);
        } else {
          //   navigate('/');
        }
      },
      (err) => {
        console.log(err, 'this is error');
        setIsLoading(false);
      },
    );
  };

  const calculatePercentage = (progressData) => {
    const percentage = (parseInt(progressData?.correctanswers) / progressData.totalquestions) * 100;
    // CALCULATE THE RESULT CONTENT ACOORDING TO PERCENTAGE

    if (percentage >= 90) {
      setResult('Excellent!');
      setResultContent('Your performance is impressive. Sounds great!');
    } else if (percentage >= 80) {
      setResult('Great job!');
      setResultContent(' You have got good scores');
    } else if (percentage >= 70) {
      setResult('Good work!');
      setResultContent(' You have a solid understanding of the concepts');
    } else if (percentage >= 60) {
      setResult('Not bad!');
      setResultContent(' You are on the right track');
    } else {
      setResult('Keep trying!');
      setResultContent(' There is room for improvement, and you can do better');
    }
  };

  return (
    <div className='container'>
      {!isLoading && (
        <div className='leaderboardcontainer'>
          <img src='/img/leaderboard.png' className='leaderboardicon' />
          <div className='otherdata'>
            <h2 className='otherdatatxt'>{result}</h2>

            <h3 className='otherdatatxt'>YOUR SCORE!</h3>
            <h1 className='yourprogressdata'>
              {parseInt(progressData?.correctanswers)}/{progressData.totalquestions}
            </h1>
            <h6 className='progressdesc'>{resultConstant}</h6>
          </div>
        </div>
      )}
      <div className='boardistcontainer mt-4'>
        <h3>LeaderBoard</h3>
        <div className='listview'>
          {scoreBoard.map((item, index) => (
            <div className='winneritem' key={index}>
              <div className='userData'>
                <div className='indexcount'>{index + 1}</div>
                <img
                  src={
                    item?.profile_image
                      ? apiConstants.imgUrl + item?.profile_image
                      : '/img/user_dummy.png'
                  }
                  className='userimg'
                />
                <div className='userotherdata'>
                  <div className='username'>{item?.first_name}</div>
                  <div className='userscore'>
                    <img src='/img/question_icon.png' className='desc_icon' />{' '}
                    {parseInt(item?.attended_questions)} attended, {parseInt(item?.total_score)}{' '}
                    correct
                  </div>
                  <div className='userscore'>
                    {millisecondsToHHMMSS(parseInt(item?.time_taken))}
                  </div>
                </div>
              </div>
              <img src='/img/trophy.png' className='trophyicon' />
            </div>
          ))}
        </div>
        <div className='d-flex justify-content-center'>
          <div
            className=' backbtn'
            onClick={() => {
              navigate('/');
            }}
          >
            <img src='/img/arowback.png' className='backicon' /> Back to Home
          </div>
        </div>
      </div>
      {/* {mode == 3 && <AnswerSheet mocktest_id={topicData?._id} />} */}
      {isLoading && <Loading />}
    </div>
  );
};
